import _ from 'lodash'
import ACTUALITY_GRID_CONFIG from './config'
import Isotope from 'isotope-layout'

class ActualityGridClass {
    constructor() {
        this.DOM = {
            section: ACTUALITY_GRID_CONFIG.section,
            grid: ACTUALITY_GRID_CONFIG.grid,
            filters: ACTUALITY_GRID_CONFIG.filters
        }

        this.filters = {}
        this.istp = null
        this.DOM.section ? this.init() : null
    }

    init() {
        this._isotope()
    }

    _listeners() {
        this.DOM.filters.forEach( ( filter ) => { filter.addEventListener( 'change', this._filter.bind( this ) ) })
    }

    _isotope() {
        this.istp = new Isotope( this.DOM.grid, {
            itemSelector: '.item',
            layoutMode: 'fitRows'
        })

        this._listeners()
    }

    _filter() {
        var checkbox = event.target;
        var group = checkbox.parentNode.parentNode.parentNode.getAttribute('data-group');
        // create array for filter group, if not there yet
        var filterGroup = this.filters[ group ];
        if ( !filterGroup ) {
            filterGroup = this.filters[ group ] = [];
        }
        // add/remove filter
        if ( checkbox.checked ) {
            // add filter
            filterGroup.push( checkbox.value );
        } else {
            // remove filter
            var index = filterGroup.indexOf( checkbox.value );
            filterGroup.splice( index, 1 );
        }
        
        var comboFilter = this._getComboFilter();
      

        this.istp.arrange({ filter: comboFilter })
    }

    _getComboFilter() {
        var combo = [];
        for ( var prop in this.filters ) {
            var group = this.filters[ prop ];
            if ( !group.length ) {
                // no this.filters in group, carry on
                continue;
            }
            // add first group
            if ( !combo.length ) {
                combo = group.slice(0);
                continue;
            }
            // add additional groups
            var nextCombo = [];
          // split group into combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
            for ( var i=0; i < combo.length; i++ ) {
                for ( var j=0; j < group.length; j++ ) {
                    var item = combo[i] + group[j];
                    nextCombo.push( item );
                }
            }
            combo = nextCombo;
        }
        var comboFilter = combo.join(', ');
        return comboFilter;
    }

    
}

const ACTUALITY_GRID = new ActualityGridClass()
export default ACTUALITY_GRID